import FingerprintJS from "@fingerprintjs/fingerprintjs"; // For browser fingerprinting
import bowser from "bowser";
import html2pdf from "html2pdf.js";
import Cookies from "js-cookie"; // Import js-cookie if not already imported
import { useCallback, useEffect, useRef, useState } from "react";
import { FaCamera, FaEdit, FaPlus, FaSave, FaTimes, FaTrash, FaPhone } from "react-icons/fa";

import { MdPayment } from "react-icons/md";
import { useNavigate } from "react-router-dom";
import { toast } from "react-toastify"; // Add this import at the top
import apiClient from "../common/apiClient";
import InvoiceTemplate from "./InvoiceTemplate";
import "./Profile.css"; // Create a separate CSS file for styling
import axios from "axios";


export const handleSaveProfilePermission = async () => {
  const token = Cookies.get("token");
  const userId = Cookies.get("userId");

  if (!token || !userId) {
    return {
      success: false,
      status: 401,
      error: "MISSING_AUTH",
    };
  }

  const response = await apiClient(
    "post",
    "/cjidnvij/ceksfbuebijn/user/v2/editprofile",
    {
      userId,
      permission: true,
    },
    {
      headers: {
        Authorization: `Bearer ${token}`,
        "Content-Type": "application/json",
      },
    }
  );

  return response;
};

const Profile = () => {
  const userId = Cookies.get("userId");
  const [showInvoice, setShowInvoice] = useState(false);
  const [isEditing, setIsEditing] = useState(false); // Add edit mode state
  const [editFormData, setEditFormData] = useState({}); // Add form data state
  const [profileImage, setProfileImage] = useState(null); // Add profile image state
  const [imagePreview, setImagePreview] = useState(null); // Add image preview state
  const [showImageModal, setShowImageModal] = useState(false); // Add this near the top with other state declarations
  const [subUser, setSubUser] = useState([]);
  const [error, setError] = useState({});
  const [loading, setLoading] = useState({});
  const [editingSubUser, setEditingSubUser] = useState({}); // Track which subUser is in edit mode
  const [showAddStaffModal, setShowAddStaffModal] = useState(false);
  const [subUserLimit, setSubUserLimit] = useState(3); // ← add this
  const [showDeleteConfirm, setShowDeleteConfirm] = useState(false);
  const [subUserToDelete, setSubUserToDelete] = useState(null);

  // 1) Add devices to initial state
  const [profileData, setProfileData] = useState({
    name: "",
    contactNumber: "",
    companyName: "",
    email: "",
    address: "",
    paymentHistory: [],
    joinedOn: "",
    activePlanDetails: null,
    deviceName: "",
    deviceId: "",
    devices: [], // <-- added
    userGSTNo: "",
    isCurrentDevice: "",
    profileImage: "",
    isPremium: "",
    userHierarchy: "",
  });

  const formatDate = (dateString) => {
    const date = new Date(dateString);
    const day = String(date.getDate()).padStart(2, "0"); // Add leading zero if needed
    const month = String(date.getMonth() + 1).padStart(2, "0"); // Months are 0-indexed
    const year = date.getFullYear();

    return `${day}-${month}-${year}`;
  };

  const calculateDaysLeft = (endDate) => {
    const now = new Date();
    const end = new Date(endDate);
    const timeDiff = end.getTime() - now.getTime();
    return Math.max(Math.floor(timeDiff / (1000 * 3600 * 24)), 0);
  };

  // Return image path for certain device types (served from public/image)
  const getDeviceImagePath = (deviceName) => {
    if (!deviceName) return null;
    const name = deviceName.toLowerCase();
    // Phones/Tablets → dedicated phone image
    if (name.includes("iphone") || name.includes("ipad") || name.includes("android")) {
      return "./image/purepng.com-samsung-phonesmartphoneandroidgooglephoneapplication-211519339028ghq1u.png"; // 1:1, transparent background
    }
    // Laptops/Desktops → dedicated laptop image
    if (name.includes("windows") || name.includes("mac") || name.includes("linux")) {
      return "./image/OIP (1).webp";
    }
    return null;
  };

  // Add function to get device icon based on device name
  const getDeviceIcon = (deviceName) => {
    if (!deviceName) return "🖥️"; // Default icon

    const name = deviceName.toLowerCase();

    if (name.includes("windows")) {
      return "💻"; // Laptop icon for Windows
    } else if (name.includes("mac") || name.includes("iphone") || name.includes("ipad")) {
      return "🍎"; // Apple icon for Mac/iOS
    } else if (name.includes("android")) {
      return "📱"; // Mobile icon for Android
    } else if (name.includes("linux")) {
      return "🐧"; // Linux penguin
    } else if (name.includes("chrome")) {
      return "🌐"; // Browser icon
    } else if (name.includes("firefox")) {
      return "🦊"; // Firefox fox
    } else if (name.includes("safari")) {
      return "🌊"; // Safari wave
    } else if (name.includes("edge")) {
      return "💎"; // Edge diamond
    } else {
      return "🖥️"; // Default computer icon
    }
  };

  // Add function to get device type label
  const getDeviceType = (deviceName) => {
    if (!deviceName) return "Unknown Device";

    const name = deviceName.toLowerCase();

    if (name.includes("windows")) {
      return "Windows Device";
    } else if (name.includes("mac")) {
      return "Mac Device";
    } else if (name.includes("iphone")) {
      return "iPhone";
    } else if (name.includes("ipad")) {
      return "iPad";
    } else if (name.includes("android")) {
      return "Android Device";
    } else if (name.includes("linux")) {
      return "Linux Device";
    } else {
      return "Web Browser";
    }
  };

  const handleDeleteDevice = async (deviceId) => {
    try {
      const token = Cookies.get("token"); // Get the authentication token

      if (!token) {
        // console.error("No authentication token found");
        return;
      }

      await apiClient(
        "post",
        "/cjidnvij/ceksfbuebijn/user/v2/device/remove",
        { deviceId },
        {
          headers: {
            Authorization: `Bearer ${token}`, // Add Bearer token
            "Content-Type": "application/json",
          },
        }
      );

      // Update UI instantly
      setProfileData((prev) => ({
        ...prev,
        devices: prev.devices.filter((d) => d.deviceId !== deviceId),
      }));

      // Show success toast with device ID
      toast.success(`Device removed successfully! Device ID: ${deviceId}`, {
        position: "top-right",
        autoClose: 3000,
        hideProgressBar: false,
        closeOnClick: true,
        pauseOnHover: true,
        draggable: true,
      });

      // console.log("Device removed:", deviceId);
    } catch (error) {
      // console.error("Error removing device:", error);
      // Show error toast
      toast.error("Failed to remove device. Please try again.", {
        position: "top-right",
        autoClose: 3000,
        hideProgressBar: false,
        closeOnClick: true,
        pauseOnHover: true,
        draggable: true,
      });
    }
  };

  // Handle edit mode toggle
  const handleEditToggle = () => {
    if (isEditing) {
      // Cancel edit - reset form data
      setEditFormData({});
      setProfileImage(null);
      setImagePreview(null);
      setIsEditing(false);
    } else {
      // Start editing - populate form with current data
      setEditFormData({
        name: profileData.name,
        companyName: profileData.companyName,
        email: profileData.email,
        address: profileData.address,
        userGSTNo: profileData.userGSTNo || ""
      });
      setIsEditing(true);
    }
  };

  // Handle form input changes
  const handleInputChange = (e) => {
    const { name, value } = e.target;
    setEditFormData(prev => ({
      ...prev,
      [name]: value
    }));
  };

  // Handle image upload
  const handleImageUpload = (e) => {
    const file = e.target.files[0];
    if (file) {
      setProfileImage(file);
      // Create preview URL
      const reader = new FileReader();
      reader.onload = (e) => {
        setImagePreview(e.target.result);
      };
      reader.readAsDataURL(file);
    }
  };

  // Handle save profile
  // Handle save profile
  const handleSaveProfile = async () => {
    try {
      const token = Cookies.get("token");

      if (!token) {
        toast.error("No authentication token found");
        return;
      }

      // Helper: collect only changed, non-empty fields (and validate email)
      const collectChanges = () => {
        const localChanges = {};
        const payload = {};

        // map local field -> backend key
        const fieldMap = {
          companyName: "companyName",
          name: "name",
          address: "address",
          email: "email",
          userGSTNo: "UserGSTNO",
        };

        const fields = Object.keys(fieldMap);
        fields.forEach((field) => {
          const newVal = (editFormData[field] ?? "").toString().trim();
          const oldVal = (profileData[field] ?? "").toString().trim();
          if (newVal && newVal !== oldVal) {
            if (field === "email") {
              const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
              if (!emailRegex.test(newVal)) {
                throw new Error("INVALID_EMAIL");
              }
            }
            localChanges[field] = newVal;
            payload[fieldMap[field]] = newVal;
          }
        });

        return { localChanges, payload };
      };

      const { localChanges: changes, payload } = collectChanges();

      let response;
      if (profileImage) {
        // Multipart path: only append changed fields + image
        const formData = new FormData();
        formData.append("userId", userId);
        formData.append("profileImage", profileImage);
        // append payload keys (backend field names)
        Object.keys(payload).forEach((key) => {
          formData.append(key, payload[key]);
        });

        response = await apiClient(
          "post",
          "/cjidnvij/ceksfbuebijn/user/v2/editprofile",
          formData,
          {
            headers: {
              Authorization: `Bearer ${token}`,
              // boundary auto-set
            },
          }
        );
      } else {
        // JSON path: send only changed fields
        const jsonPayload = { userId, ...payload };

        // If nothing changed, no need to call API
        if (Object.keys(changes).length === 0) {
          setIsEditing(false);
          setEditFormData({});
          setProfileImage(null);
          setImagePreview(null);
          toast.info("No changes to save");
          return;
        }

        response = await apiClient(
          "post",
          "/cjidnvij/ceksfbuebijn/user/v2/editprofile",
          jsonPayload,
          {
            headers: {
              Authorization: `Bearer ${token}`,
              "Content-Type": "application/json",
            },
          }
        );
      }

      // Update local profile data only for fields that changed
      // Update local profile data only for fields that changed
      const serverImage = response?.data?.data?.user?.profileImage;
      const cacheBusted =
        serverImage ? `${serverImage}${serverImage.includes('?') ? '&' : '?'}_=${Date.now()}` : null;

      setProfileData((prev) => ({
        ...prev,
        ...changes,
        // Prefer freshly returned URL (with cache-bust). If none, keep showing the local preview if an image was uploaded.
        profileImage: cacheBusted || (profileImage ? (imagePreview || prev.profileImage) : prev.profileImage),
      }));

      // Exit edit mode
      setIsEditing(false);
      setEditFormData({});
      setProfileImage(null);
      // Only clear preview if no upload happened OR we have a fresh server URL
      if (!profileImage || cacheBusted) {
        setImagePreview(null);
      }

      toast.success("Profile updated successfully!", {
        position: "top-right",
        autoClose: 3000,
        hideProgressBar: false,
        closeOnClick: true,
        pauseOnHover: true,
        draggable: true,
      });
    } catch (error) {
      if (error.message === "INVALID_EMAIL") {
        toast.error("Please enter a valid email address");
        return;
      }
      const msg =
        error?.response?.data?.message ||
        "Failed to update profile. Please try again.";
      // console.error("Error updating profile:", error);
      toast.error(msg, {
        position: "top-right",
        autoClose: 3000,
        hideProgressBar: false,
        closeOnClick: true,
        pauseOnHover: true,
        draggable: true,
      });
    }
  };

  useEffect(() => {
    // Fetch user profile data from API
    const fetchProfileData = async () => {
      try {
        const response = await apiClient(
          "post",
          `/cjidnvij/ceksfbuebijn/user/dsvsdv/v2/casadyt/${userId}/csauyv`
        );
        // const response = await axios.post(
        //   `${process.env.REACT_APP_API_IP}/cjidnvij/ceksfbuebijn/user/dsvsdv/v2/casadyt/${userId}/csauyv`
        // );
        const data = response.data.data.user; // Extract 'data' from response
        const subusers = response.data.data.subusers
        const subUserLimit = response.data.data.subUserLimit;
        setSubUserLimit(subUserLimit ?? 3);

        // Compute current-device flag by comparing against cookie deviceId
        const currentDeviceId = Cookies.get("deviceId");
        const devicesWithFlag = (data.devices || []).map((d) => ({
          ...d,
          isCurrentDevice: currentDeviceId ? d.deviceId === currentDeviceId : false,

        }));


        const foundCurrentDevice = devicesWithFlag.find((d) => d.isCurrentDevice);
        if (foundCurrentDevice) {

        } else {

        }

        const currentDevice =
          devicesWithFlag.find((d) => d.isCurrentDevice) || devicesWithFlag[0] || {};

        const mappedSubUsers = subusers.map((sData, sIndex) => {
          return {
            id: sData._id,
            companyName: sData.companyName,
            name: sData.name,
            number: sData.number,
            email: sData.email,
            address: sData.address,
            profileImage: sData.profileImage || "",
            isActive: true
          }
        })

        setProfileData({
          name: data.name,
          contactNumber: data.number,
          companyName: data.companyName,
          email: data.email,
          address: data.address,
          userGSTNo: data.userGSTNo || data.UserGSTNO || "",
          joinedOn: formatDate(data.createdOn),
          paymentHistory: response.data.data.paymentHistory || [],
          activePlanDetails: data.activePlanDetails || null,
          deviceName: currentDevice.deviceName || "",
          deviceId: currentDevice.deviceId || "",
          devices: devicesWithFlag,
          profileImage: data.profileImage || "",
          isPremium: data.isPremium,
          userHierarchy: data.userHierarchy
        });

        setSubUser(mappedSubUsers)
      } catch (error) {
        console.error("Error fetching profile data:", error);
      }
    };
    fetchProfileData();
  }, [userId]);

  const latestPayment = profileData.paymentHistory[0];

  const downloadInvoice = () => {
    setShowInvoice(true);
    setTimeout(() => {
      const element = document.getElementById("invoice-content");
      html2pdf().from(element).save("invoice.pdf");
      setShowInvoice(false);
    }, 100);
  };

  const ImagePreviewModal = ({ imageUrl, onClose }) => {
    const handleClick = (e) => {
      if (e.target === e.currentTarget) {
        onClose();
      }
    };

    return (
      <div className="image-preview-modal" onClick={handleClick}>
        <button className="close-modal" onClick={onClose}>
          <FaTimes />
        </button>
        <img
          src={imageUrl}
          alt="Profile Preview"
          className="modal-image"
        />
      </div>
    );
  };

  useEffect(() => {
    const handleKeyDown = (e) => {
      if (e.key === 'Escape' && showImageModal) {
        setShowImageModal(false);
      }
    };

    if (showImageModal) {
      document.addEventListener('keydown', handleKeyDown);
    }

    return () => {
      document.removeEventListener('keydown', handleKeyDown);
    };
  }, [showImageModal]);


  const navigate = useNavigate();

  const handleMyPropertyClick = () => {
    navigate("/MyProperty");
  };


  // const handleRequirementClick = () => {
  //   navigate("/MyRequirment");
  // };

  const handleSubUserBoilerPlate = () => {
    const maxSubUserLimit = subUserLimit;
    if (subUser.length >= maxSubUserLimit) {
      toast.info(`You can only add upto ${maxSubUserLimit} staff members.`, {
        position: "top-right",
        autoClose: 3000,
        hideProgressBar: false,
      });
      return false;
    }

    const subUserFields = {
      id: subUser.length + 1,
      companyName: profileData.companyName,
      name: "",
      number: "",
      email: "",
      address: profileData.address,
      isPremium: profileData.isPremium,
      limit: 0,
      wrongPassLimit: 10,
      createdOn: new Date(),
      isActive: false
    }

    const checkInActive = subUser.filter((s) => s.isActive === false);

    if (checkInActive.length > 0) {
      return false;
    }

    setSubUser([...subUser, subUserFields])
    setShowAddStaffModal(true);
  }

  /* useEffect(() => {
    console.log(subUser)
  }, [subUser]) */

  const getDeviceDetails = () => {
    const browser = bowser.getParser(window.navigator.userAgent);
    const info = browser.getResult();

    return {
      browser: info.browser.name,
      browserVersion: info.browser.version,
      os: info.os.name,
      osVersion: info.os.version,
      platform: info.platform.type,
      screenResolution: `${window.screen.width}x${window.screen.height}`,
      userAgent: navigator.userAgent,
    };
  };

  // Function to get browser fingerprint (unique ID for the browser)
  const getFingerprint = async () => {
    const fp = await FingerprintJS.load();
    const result = await fp.get();
    return result.visitorId; // Unique ID for browser
  };

  // Function to get the user's IP address
  const getIPAddress = async () => {
    try {
      const response = await axios.get("https://api.ipify.org?format=json");
      return response.data.ip; // Returns the IP address of the user
    } catch (error) {
      // console.error("Unable to fetch IP address", error);
      return null;
    }
  };

  const debounceTimers = useRef({});


  const handleSubUserInputChange = useCallback((index, fieldName, e) => {
    const value = e.target.value;

    // Clear existing timer for this field
    if (debounceTimers.current[`${index}-${fieldName}`]) {
      clearTimeout(debounceTimers.current[`${index}-${fieldName}`]);
    }

    // Set new timer
    debounceTimers.current[`${index}-${fieldName}`] = setTimeout(() => {
      setSubUser(prev => {
        const updated = [...prev];
        updated[index] = { ...updated[index], [fieldName]: value };
        return updated;
      });
    }, 300);
  }, []);

  const handleSubUserSaveProfile = async (index) => {
    const name = subUser[index].name
    const companyName = subUser[index].companyName
    const number = subUser[index].number
    const email = subUser[index].email
    const address = subUser[index].address
    const deviceDetails = getDeviceDetails(); // Get device details here
    const fingerprint = await getFingerprint(); // Get browser fingerprint
    const ipAddress = await getIPAddress(); // Get user's IP address
    const userHierarchy = 'subuser';
    const parentUserId = userId
    const isPremium = subUser[index].isPremium

    setError(prev => {
      const newError = { ...prev };
      delete newError[index];
      return newError;
    });

    // Validate form fields
    if (!name || !number || !email) {
      setError(prev => ({ ...prev, [index]: "All fields are required." }));
      return;
    }

    // Validate contact number format
    const contactPattern = /^[0-9]{10}$/; // Example pattern for 10-digit numbers
    if (!contactPattern.test(number)) {
      setError(prev => ({ ...prev, [index]: "Invalid contact number format." }));
      return;
    }

    const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
    if (!emailRegex.test(email)) {
      setError(prev => ({ ...prev, [index]: "Please enter a valid email address." }));
      return;
    }

    setLoading(prev => ({ ...prev, [index]: true }));

    try {
      const response = await apiClient(
        "post",
        "/cjidnvij/ceksfbuebijn/user/v2/signin/vkjdbfuhe/nkdkjbed",
        {
          companyName,
          email,
          address,
          name,
          number,
          userHierarchy,
          parentUserId,
          isPremium
        }
      );

      // Handle API SUCCESS/FAIL
      if (!response.success) {
        setError(prev => ({ ...prev, [index]: response.error?.message || "Add staff create failed." }));
        console.log(response.error?.message || "Staff create failed.");
        return;
      }

      const res = response.data; // decrypted or normal response

      if (res.status === "success") {
        window.location.reload();
      } else {
        console.log(res.message || "Unexpected error");
      }

    } catch (err) {
      console.log("Unexpected failure. Please try again.");
    } finally {
      setLoading(prev => ({ ...prev, [index]: false }));
    }
  }

  const handleSubUserUpdateProfile = async (data, index) => {
    const token = Cookies.get("token");

    if (!token) {
      toast.error("No authentication token found");
      return;
    }

    const name = data.name
    const userId = data.id

    setError(prev => {
      const newError = { ...prev };
      delete newError[index];
      return newError;
    });

    if (!name) {
      setError(prev => ({ ...prev, [index]: "Please enter the name." }));
      return;
    }

    setLoading(prev => ({ ...prev, [index]: true }));

    try {
      const response = await apiClient(
        "post",
        "/cjidnvij/ceksfbuebijn/user/v2/editprofile",
        { name, userId },
      );

      // Handle API SUCCESS/FAIL
      if (!response.success) {
        console.log(response.error?.message || "Staff create failed.");
        return;
      }

      const res = response.data; // decrypted or normal response

      if (res.success) {
        window.location.reload();
      } else {
        console.log(res.message || "Unexpected error");
      }

    } catch (err) {
      console.log("Unexpected failure. Please try again.");
    } finally {
      setLoading(prev => ({ ...prev, [index]: false }));
    }
  }

  const handleRemove = (data, index) => {
    setSubUserToDelete({ data, index });
    setShowDeleteConfirm(true);
  };

  const confirmDelete = async () => {
    if (subUserToDelete) {
      const { data, index } = subUserToDelete;
      await handleDeleteSubUser(data, index);
      setShowDeleteConfirm(false);
      setSubUserToDelete(null);
    }
  };

  const handleDeleteSubUser = async (data, index) => {
    if (!data.isActive) {
      setSubUser(prev => prev.filter(user => user.id !== data.id));
      setShowAddStaffModal(false);
      setError(prev => {
        const newError = { ...prev };
        delete newError[index];
        return newError;
      });
      setShowDeleteConfirm(false);
      setSubUserToDelete(null);
      return
    }

    const userId = data.id
    try {
      const response = await apiClient(
        "post",
        "/cjidnvij/ceksfbuebijn/user/qujaidaxc/v2/deleteSubuser/uijdisdna",
        { userId }
      );

      // Handle API SUCCESS/FAIL
      if (!response.success) {
        setError(prev => ({ ...prev, [index]: response.error?.message || "Staff create failed." }));
        console.log(response.error?.message || "Staff create failed.");
        return;
      }

      const res = response.data; // decrypted or normal response

      if (res.success) {
        window.location.reload();
      } else {
        console.log(res.message || "Unexpected error");
      }

    } catch (err) {
      console.log("Unexpected failure. Please try again.");
    } finally {
      setLoading(prev => ({ ...prev, [index]: false }));
    }
  }

  return (
    <div className="profile-container">
      <div className="profile-header">
        <div
          className="profile-icon"
          onClick={() => profileData.profileImage && setShowImageModal(true)}
          style={{ cursor: profileData.profileImage ? "pointer" : "default" }}
        >
          <svg
            width="83"
            height="83"
            viewBox="0 0 83 83"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
          >
            <circle opacity="0.2" cx="41.5" cy="41.5" r="41.5" fill="#6200E8" />
            <defs>
              <clipPath id="avatarClip">
                <circle cx="41.5" cy="41.5" r="37.8" />
              </clipPath>
            </defs>
            {(imagePreview || profileData.profileImage) ? (
              <image
                href={imagePreview || profileData.profileImage}
                x="3.7"
                y="3.7"
                height="75.6"
                width="75.6"
                clipPath="url(#avatarClip)"
                preserveAspectRatio="xMidYMid meet"
              />
            ) : (
              <image
                x="3.7"
                y="3.7"
                height="75.6"
                width="75.6"
                href={imagePreview || profileData.profileImage || "./image/image-42.png"}
                clipPath="url(#avatarClip)"
                preserveAspectRatio="xMidYMid meet"
              />
            )}
            {isEditing && (
              <g>
                <circle cx="65" cy="65" r="12" fill="#6200E8" />
                <foreignObject x="59" y="59" width="12" height="12">
                  <label style={{ cursor: "pointer", color: "white", fontSize: "10px" }}>
                    <FaCamera />
                    <input
                      type="file"
                      accept="image/*"
                      onChange={handleImageUpload}
                      style={{ display: "none" }}
                    />
                  </label>
                </foreignObject>
              </g>
            )}
          </svg>
        </div>

        <h2>Your Profile</h2>

        <div className="profile-header-actions">
          {/* {profileData.userHierarchy === 'main' && <button className="edit-profile-btn" onClick={handleSubUserBoilerPlate}>
            <FaPlus size={12} />
            Add Staff
          </button>} */}
          {!isEditing ? (
            <button onClick={handleEditToggle} className="edit-profile-btn">
              <FaEdit size={12} />
              Edit Profile
            </button>
          ) : (
            <div style={{ display: "flex", gap: "8px" }}>
              <button onClick={handleSaveProfile} className="save-profile-btn">
                <FaSave size={12} />
                Save
              </button>
              <button onClick={handleEditToggle} className="cancel-edit-btn">
                <FaTimes size={12} />
                Cancel
              </button>
            </div>
          )}
        </div>
      </div>


      {/* {profileData.activePlanDetails && (
        <div className="active-plan-details">
          <h2>Active Plan Details</h2>
          <div className="plan-grid">
            <div className="plan-item">
              <strong>Purchased On:</strong>
              <span>{formatDate(profileData.activePlanDetails.paidOn)}</span>
            </div>
            <div className="plan-item">
              <strong>Expired On:</strong>
              <span>{formatDate(profileData.activePlanDetails.expiredOn)}</span>
            </div>
            <div className="plan-item">
              <strong>Days Remaining:</strong>
              <span>
                {calculateDaysLeft(profileData.activePlanDetails.expiredOn)}
              </span>
            </div>
            <div className="plan-item">
              <strong>Status:</strong>
              <span>
                {calculateDaysLeft(profileData.activePlanDetails.expiredOn) > 0
                  ? "Active"
                  : "Expired"}
              </span>
            </div>
          </div>
        </div>
      )} */}

      <div className="profile-details">
        <div className="profile-field">
          <label>Name</label>
          <div className="profile-input">
            {isEditing ? (
              <input
                type="text"
                name="name"
                value={editFormData.name || ""}
                onChange={handleInputChange}
                placeholder="Enter your name"
                style={{
                  border: '1px solid #ddd',
                  borderRadius: '4px',
                  padding: '8px',
                  width: '100%'
                }}
              />
            ) : (
              <input type="text" value={profileData.name} readOnly />
            )}
          </div>
        </div>

        <div className="profile-field">
          <label>Contact Number</label>
          <div className="profile-input">
            <input type="text" value={profileData.contactNumber} readOnly />
          </div>
        </div>

        <div className="profile-field">
          <label>Company Name</label>
          <div className="profile-input">
            {isEditing ? (
              <input
                type="text"
                name="companyName"
                value={editFormData.companyName || ""}
                onChange={handleInputChange}
                placeholder="Enter company name"
                style={{
                  border: '1px solid #ddd',
                  borderRadius: '4px',
                  padding: '8px',
                  width: '100%'
                }}
              />
            ) : (
              <input type="text" value={profileData.companyName} readOnly />
            )}
          </div>
        </div>

        <div className="profile-field">
          <label>Email</label>
          <div className="profile-input">
            {isEditing ? (
              <input
                type="email"
                name="email"
                value={editFormData.email || ""}
                onChange={handleInputChange}
                placeholder="Enter email address"
                style={{
                  border: '1px solid #ddd',
                  borderRadius: '4px',
                  padding: '8px',
                  width: '100%'
                }}
              />
            ) : (
              <input type="text" value={profileData.email} readOnly />
            )}
          </div>
        </div>

            <div className="profile-field">
              <label>User GST NO</label>
              <div className="profile-input">
                {isEditing ? (
                  <input
                    type="text"
                    name="userGSTNo"
                    value={editFormData.userGSTNo || ""}
                    onChange={handleInputChange}
                    placeholder="Enter GST number"
                    style={{
                      border: '1px solid #ddd',
                      borderRadius: '4px',
                      padding: '8px',
                      width: '100%'
                    }}
                  />
                ) : (
                  <input type="text" value={profileData.userGSTNo || ""} readOnly />
                )}
              </div>
            </div>

        <div className="profile-field">
          <label>Address</label>
          <div className="profile-input">
            {isEditing ? (
              <textarea
                name="address"
                value={editFormData.address || ""}
                onChange={handleInputChange}
                placeholder="Enter address"
                rows={3}
                style={{
                  border: '1px solid #ddd',
                  borderRadius: '4px',
                  padding: '8px',
                  width: '100%',
                  resize: 'vertical'
                }}
              />
            ) : (
              <input type="text" value={profileData.address} readOnly />
            )}
          </div>
        </div>

        <div className="profile-field">
          <label>Joined On</label>
          <div className="profile-input">
            <input type="text" value={profileData.joinedOn} readOnly />
          </div>
        </div>
      </div>
      <hr className="my-3" />
      {/* <h2 style={{ fontSize: '20px', fontWeight: 'bold', margin: '20px 0' }}>Staff Management</h2> */}
      {/* <div style={{ display: 'grid', gridTemplateColumns: 'repeat(auto-fill, minmax(280px, 1fr))', gap: '20px', marginBottom: '30px' }}>
        {subUser.filter(s => s.isActive).map((sData, sIndex) => {
          // Adjust index for editingSubUser if needed, but sIndex here is local to the filtered array.
          // Better to use actual index from original array or use ID.
          const originalIndex = subUser.findIndex(u => u.id === sData.id);
          const isEditing = editingSubUser[originalIndex];

          // Dynamic colors mirroring the screenshot (purple, green, yellow, pink)
          const bgColors = ['#ede9fe', '#d1fae5', '#fef3c7', '#ffe4e6'];
          const avatarBg = bgColors[originalIndex % bgColors.length];
          const textColors = ['#6200e8', '#10b981', '#f59e0b', '#e11d48'];
          const badgeColor = textColors[originalIndex % textColors.length];

          // Apply cache-busting if the image exists
          const imageUrl = sData.profileImage ? `${sData.profileImage}${sData.profileImage.includes('?') ? '&' : '?'}_=${Date.now()}` : "";

          if (!isEditing) {
            return (
              <div key={sData.id} style={{
                backgroundColor: 'white',
                borderRadius: '16px',
                padding: '24px',
                boxShadow: '0 4px 20px rgba(0, 0, 0, 0.05)',
                border: '1px solid #f3f4f6',
                display: 'flex',
                flexDirection: 'column',
                alignItems: 'center',
                position: 'relative',
                transition: 'transform 0.2s ease',
              }}>
                <div style={{
                  width: '80px', height: '80px', borderRadius: '50%',
                  backgroundColor: avatarBg, display: 'flex', alignItems: 'center', justifyContent: 'center',
                  marginBottom: '16px', overflow: 'hidden'
                }}>
                  {imageUrl ? (
                    <img src={imageUrl} alt={sData.name || "Profile"} style={{ width: '100%', height: '100%', objectFit: 'cover' }} />
                  ) : (
                    <svg width="40" height="40" viewBox="0 0 24 24" fill="#374151">
                      <path d="M12 12c2.21 0 4-1.79 4-4s-1.79-4-4-4-4 1.79-4 4 1.79 4 4 4zm0 2c-2.67 0-8 1.34-8 4v2h16v-2c0-2.66-5.33-4-8-4z" />
                    </svg>
                  )}
                </div>

                <h3 style={{ fontSize: '18px', fontWeight: 'bold', color: '#1f2937', marginBottom: '4px' }}>
                  {sData.name || 'Unknown Staff'} 
                </h3>

                <div style={{ display: 'flex', alignItems: 'center', gap: '8px', color: '#6b7280', fontSize: '14px', marginBottom: '16px' }}>
                  <FaPhone size={12} />
                  <span>{sData.number || 'N/A'}</span>
                </div>

                <div style={{
                  backgroundColor: avatarBg, color: badgeColor, padding: '4px 12px',
                  borderRadius: '9999px', fontSize: '12px', fontWeight: '600', marginBottom: '24px'
                }}>
                  Staff Member
                </div>

                <div style={{ width: '100%', display: 'flex', gap: '8px' }}>
                  <button
                    onClick={() => setEditingSubUser(prev => ({ ...prev, [originalIndex]: true }))}
                    style={{
                      flex: 1, padding: '8px', borderRadius: '8px',
                      backgroundColor: '#6200e8', color: 'white', border: 'none', cursor: 'pointer',
                      fontSize: '14px', fontWeight: '500', display: 'flex', justifyContent: 'center', alignItems: 'center', gap: '6px'
                    }}
                  >
                    <FaEdit size={12} />
                    Update
                  </button>
                  <button
                    onClick={() => handleRemove(sData, originalIndex)}
                    style={{
                      flex: 1, padding: '8px', borderRadius: '8px',
                      backgroundColor: '#fee2e2', color: '#dc2626', border: 'none', cursor: 'pointer',
                      fontSize: '14px', fontWeight: '500', display: 'flex', justifyContent: 'center', alignItems: 'center', gap: '6px'
                    }}
                  >
                    <FaTrash size={12} />
                    Remove
                  </button>
                </div>
              </div>
            );
          }

          return (
            <div key={sData.id} style={{ gridColumn: '1 / -1', border: '1px solid #e5e7eb', borderRadius: '8px', padding: '20px', backgroundColor: '#f9fafb' }}>
              <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', marginBottom: '16px' }}>
                <span style={{ fontWeight: 'bold', fontSize: '16px' }}>Edit Staff Member: {sData.name}</span>
                <div style={{ display: 'flex', gap: '8px' }}>
                  <button
                    onClick={() => setEditingSubUser(prev => ({ ...prev, [originalIndex]: false }))}
                    className="cancel-edit-btn"
                    style={{ padding: '6px 12px', backgroundColor: '#6b7280', border: 'none', borderRadius: '4px', color: 'white', cursor: 'pointer', display: 'flex', alignItems: 'center', gap: '4px' }}
                  >
                    <FaTimes size={12} /> Cancel
                  </button>
                  <button
                    onClick={() => handleRemove(sData, originalIndex)}
                    className="cancel-edit-btn"
                    style={{ padding: '6px 12px', backgroundColor: '#dc2626', border: 'none', borderRadius: '4px', color: 'white', cursor: 'pointer', display: 'flex', alignItems: 'center', gap: '4px' }}
                  >
                    <FaTrash size={12} /> Remove
                  </button>
                </div>
              </div>

              <div className="profile-details">
                <div className="profile-field">
                  <label>Name</label>
                  <div className="profile-input">
                    <input
                      type="text"
                      onChange={(e) => handleSubUserInputChange(originalIndex, 'name', e)}
                      defaultValue={sData.name}
                      placeholder="Enter your name"
                      style={{ border: '1px solid #ddd', borderRadius: '4px', padding: '10px', width: '100%', backgroundColor: '#fff' }}
                    />
                  </div>
                </div>

                <div className="profile-field">
                  <label>Contact Number</label>
                  <div className="profile-input">
                    <input
                      type="text"
                      readOnly
                      defaultValue={sData.number}
                      style={{ border: '1px solid #ddd', borderRadius: '4px', padding: '10px', width: '100%', backgroundColor: '#f3f4f6', cursor: 'not-allowed' }}
                    />
                  </div>
                </div>

                <div className="profile-field">
                  <label>Email</label>
                  <div className="profile-input">
                    <input
                      type="text"
                      readOnly
                      defaultValue={sData.email}
                      style={{ border: '1px solid #ddd', borderRadius: '4px', padding: '10px', width: '100%', backgroundColor: '#f3f4f6', cursor: 'not-allowed' }}
                    />
                  </div>
                </div>
              </div>

              {error[originalIndex] && (
                <div className="text-red-500 bg-red-100 border border-red-500 rounded-md p-2 text-center my-2" style={{ width: '100%' }}>
                  {error[originalIndex]}
                </div>
              )}

              <div style={{ display: "flex", gap: "8px", justifyContent: "flex-end", marginTop: "15px" }}>
                <button
                  onClick={() => handleSubUserUpdateProfile(sData, originalIndex)}
                  className="save-profile-btn"
                  disabled={loading[originalIndex]}
                  style={{ padding: '8px 16px', backgroundColor: '#6200e8', color: 'white', border: 'none', borderRadius: '4px', cursor: 'pointer', display: 'flex', alignItems: 'center', gap: '6px' }}
                >
                  <FaSave size={12} />
                  {loading[originalIndex] ? "Updating..." : "Update"}
                </button>
              </div>
            </div>
          )
        })}
      </div> */}

      {/* Add Staff Modal */}
      {showAddStaffModal && (
        <div className="image-preview-modal" style={{ cursor: 'default' }}>
          <div style={{
            backgroundColor: 'white',
            borderRadius: '12px',
            width: '90%',
            maxWidth: '600px',
            padding: '30px',
            position: 'relative',
            maxHeight: '90vh',
            overflowY: 'auto'
          }}>
            <button
              onClick={() => {
                const inactiveIdx = subUser.findIndex(u => !u.isActive);
                if (inactiveIdx !== -1) handleDeleteSubUser(subUser[inactiveIdx], inactiveIdx);
                setShowAddStaffModal(false);
              }}
              style={{
                position: 'absolute', top: '15px', right: '15px',
                background: 'none', border: 'none', cursor: 'pointer', color: '#6b7280'
              }}
            >
              <FaTimes size={20} />
            </button>

            <h2 style={{ fontSize: '24px', fontWeight: 'bold', marginBottom: '25px', color: '#1f2937' }}>Add New Staff Member</h2>

            {subUser.filter(s => !s.isActive).map((sData, sIndex) => {
              const originalIndex = subUser.findIndex(u => u.id === sData.id);
              return (
                <div key={sData.id}>
                  <div className="profile-details" style={{ display: 'flex', flexDirection: 'column' }}>
                    <div className="profile-field" style={{ flex: '1 1 100%' }}>
                      <label>Name</label>
                      <div className="profile-input">
                        <input
                          type="text"
                          onChange={(e) => handleSubUserInputChange(originalIndex, 'name', e)}
                          placeholder="Enter staff name"
                          style={{ border: '1px solid #ddd', borderRadius: '4px', padding: '12px', width: '100%' }}
                        />
                      </div>
                    </div>

                    <div className="profile-field" style={{ flex: '1 1 100%' }}>
                      <label>Contact Number</label>
                      <div className="profile-input">
                        <input
                          type="text"
                          onChange={(e) => handleSubUserInputChange(originalIndex, 'number', e)}
                          placeholder="Enter 10-digit number"
                          style={{ border: '1px solid #ddd', borderRadius: '4px', padding: '12px', width: '100%' }}
                        />
                      </div>
                    </div>

                    <div className="profile-field" style={{ flex: '1 1 100%' }}>
                      <label>Email</label>
                      <div className="profile-input">
                        <input
                          type="text"
                          onChange={(e) => handleSubUserInputChange(originalIndex, 'email', e)}
                          placeholder="Enter email address"
                          style={{ border: '1px solid #ddd', borderRadius: '4px', padding: '12px', width: '100%' }}
                        />
                      </div>
                    </div>

                  </div>

                  {error[originalIndex] && (
                    <div className="text-red-500 bg-red-100 border border-red-500 rounded-md p-3 text-center my-4">
                      {error[originalIndex]}
                    </div>
                  )}

                  <div style={{ display: "flex", gap: "12px", justifyContent: "flex-end", marginTop: '20px' }}>
                    <button
                      onClick={() => {
                        handleDeleteSubUser(subUser[originalIndex], originalIndex);
                        setShowAddStaffModal(false);
                      }}
                      className="cancel-edit-btn"
                      style={{ padding: '10px 20px', borderRadius: '6px' }}
                    >
                      Cancel
                    </button>
                    <button
                      onClick={() => handleSubUserSaveProfile(originalIndex)}
                      className="save-profile-btn"
                      disabled={loading[originalIndex]}
                      style={{ padding: '10px 25px', borderRadius: '6px', backgroundColor: '#6200e8' }}
                    >
                      {loading[originalIndex] ? "Saving..." : "Save Staff"}
                    </button>
                  </div>
                </div>
              );
            })}
          </div>
        </div>
      )}

      {/* {{profileData.paymentHistory.length > 0 && (
        <div className="payment-history">
          <h1>Payment History</h1>
          <div className="payment-records">
            {profileData.paymentHistory.map((payment, index) => (
              <div key={index} className="payment-record">
                <div>Name: {payment.name}</div>
                <div className="amount">Amount: ₹{payment.amount}</div>
                <div className="payment-mode">
                  <MdPayment />
                  Payment Mode: {payment.paymentMode}
                </div>
                <div>OrderId: {payment.orderId}</div>
                <div>Paid to: {payment.agentName}</div>
                <div>Status: {payment.status}</div>
                <div>Paid On: {formatDate(payment.createdOn)}</div>
                <div>Expired On: {formatDate(payment.expiredDate)}</div>
                <button onClick={downloadInvoice} className="bg-purple-800 text-white px-4 py-2 rounded-md ">Download Invoice</button>
              </div>
            ))}
          </div>
        </div>
      )}} */}
      {/*  
      {profileData.devices && profileData.devices.length > 0 && (
        <div className="devices-section">
          <h2 className="devices-section-title">
            <span className="devices-icon">💻</span>
            Connected Devices ({profileData.devices.length})
          </h2>
          <div className="devices-grid">
            {profileData.devices
              .sort((a, b) => (b.isCurrentDevice ? 1 : -1)) // Sort current device to top
              .map((device, idx) => (
                <div
                  className={`device-card ${device.isCurrentDevice ? 'current-device' : ''}`}
                  key={device.deviceId || idx}
                >
                  <div className="device-card-header">
                    <div className="device-icon-container">
                      {getDeviceImagePath(device.deviceName) ? (
                        <img
                          className={`device-icon ${device.deviceName.toLowerCase().includes('windows') ? 'windows-device-icon' : ''}`}
                          src={getDeviceImagePath(device.deviceName)}
                          alt={getDeviceType(device.deviceName)}
                        />
                      ) : (
                        <span className="device-icon">{getDeviceIcon(device.deviceName)}</span>
                      )}
                    </div>
                    <div className="device-info">
                      <div className="device-info-header">
                        <p className="device-type">{getDeviceType(device.deviceName)}</p>
                        <button
                          className="current-device-badge"
                          title="Delete Device"
                          onClick={() => handleDeleteDevice(device.deviceId)}
                        >
                          Remove
                        </button>
                      </div>
                      <div className="device-detail-row">
                        <span className="detail-label">ID:</span>
                        <span className="detail-value">{device.deviceId || "N/A"}</span>
                      </div>
                    </div>
                  </div>
                </div>
              ))}
          </div>
        </div>
      )}
*/}
      <div>
        {/* In your JSX: */}
        {showInvoice && (
          <InvoiceTemplate user={profileData} payment={latestPayment} />
        )}
        {/* <InvoiceTemplate user={profileData} payment={latestPayment} /> */}
      </div>

      {/* Confirmation Modal for deletion */}
      {showDeleteConfirm && (
        <div className="image-preview-modal" style={{ zIndex: 2000 }}>
          <div style={{
            backgroundColor: 'white',
            borderRadius: '24px',
            padding: '32px',
            width: '90%',
            maxWidth: '430px',
            textAlign: 'center',
            boxShadow: '0 25px 50px -12px rgba(0, 0, 0, 0.25)',
            border: '1px solid #f3f4f6',
            position: 'relative'
          }}>
            <div style={{
              width: '64px',
              height: '64px',
              borderRadius: '50%',
              backgroundColor: '#fee2e2',
              display: 'flex',
              alignItems: 'center',
              justifyContent: 'center',
              margin: '0 auto 24px',
              animation: 'pulseRed 2s infinite'
            }}>
              <FaTrash size={28} color="#dc2626" />
            </div>

            <h3 style={{
              fontSize: '22px',
              fontWeight: '700',
              color: '#111827',
              marginBottom: '12px'
            }}>
              Confirm Staff Removal
            </h3>

            <p style={{
              color: '#4b5563',
              marginBottom: '32px',
              lineHeight: '1.6',
              fontSize: '15px'
            }}>
              Are you sure you want to remove <span style={{ fontWeight: '600', color: '#111827' }}>{subUserToDelete?.data?.name || 'this staff member'}</span>? All access for this staff member will be immediately revoked.
            </p>

            <div style={{ display: 'flex', gap: '12px' }}>
              <button
                onClick={() => {
                  setShowDeleteConfirm(false);
                  setSubUserToDelete(null);
                }}
                style={{
                  flex: 1,
                  padding: '12px 20px',
                  borderRadius: '12px',
                  border: '1px solid #e5e7eb',
                  backgroundColor: 'white',
                  color: '#374151',
                  fontWeight: '600',
                  cursor: 'pointer',
                  fontSize: '15px',
                  transition: 'background-color 0.2s'
                }}
              >
                No, Keep
              </button>
              <button
                onClick={confirmDelete}
                style={{
                  flex: 1,
                  padding: '12px 20px',
                  borderRadius: '12px',
                  border: 'none',
                  backgroundColor: '#dc2626',
                  color: 'white',
                  fontWeight: '600',
                  cursor: 'pointer',
                  fontSize: '15px',
                  transition: 'opacity 0.2s',
                  boxShadow: '0 4px 6px -1px rgba(220, 38, 38, 0.4)'
                }}
              >
                Yes, Remove
              </button>
            </div>
          </div>
        </div>
      )}

      {/* Image preview modal */}
      {showImageModal && (
        <ImagePreviewModal
          imageUrl={profileData.profileImage}
          onClose={() => setShowImageModal(false)}
        />
      )}
    </div>
  );
};

export default Profile;
